import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        // ui static words
        submit: "Submit",
        cancel: "Cancel",
        close: "Close",
        create: "Create",
        languageSwitched: "Language switched successfully!",
        add_new_category: "Add new category",
        category: "Category",
        create_category: "Create category",
        edit_category: "Edit category",
        category_name: "Category name",
        sub_category: "Sub category",
        create_sub_category: "Create sub category",
        add_new_sub_category: "Add new sub category",
        select_category: "Select category",
        select_an_option: "Select an option",
        sub_category_name: "Sub category name",
        enter_sub_category_name: "Enter sub category name",
        enter_category_name: "Enter category name",
        edit_sub_category: "Edit sub category",
        select_a_category: "Select a category",
        item_size: "Size",
        add_new_item_size: "Add new size",
        create_item_size: "Create size",
        item_size_name: "Size name",
        edit_item_size: "Edit size",
        item_color: "Color",
        add_new_item_color: "Add new color",
        create_item_color: "Create color",
        item_color_name: "Color name",
        edit_item_color: "Edit color",
        store: "Store",
        add_new_store: "Add new store",
        store_name: "Store name",
        store_address: "Store address",
        store_phone_number: "Store phone number",
        create_store: "Create store",
        edit_store: "Edit store",
        warehouse: "Warehouse",
        add_new_warehouse: "Add new warehouse",
        warehouse_name: "Warehouse name",
        warehouse_address: "Warehouse address",
        warehouse_phone_number: "Warehouse phone number",
        create_warehouse: "Create warehouse",
        edit_warehouse: "Edit warehouse",
        supplier: "Supplier",
        customer: "Customer",
        party_type: "Party Type",
        party_type_optional: "Party Type (Optional)",
        party: "Party",
        add_new_supplier: "Add new supplier",
        supplier_name: "Supplier name",
        supplier_address: "Supplier address",
        supplier_phone_number: "Supplier phone number",
        create_supplier: "Create supplier",
        edit_supplier: "Edit supplier",
        measurement_unit: "Units",
        add_new_measurement_unit: "Add new unit",
        create_measurement_unit: "Create unit",
        edit_measurement_unit: "Edit unit",
        item: 'Item',
        select_item:'Search Item',
        add_new_item: 'Add new item',
        import_item: 'Import Item',
        export_item: 'Export Item',
        import_items: 'Import Items',
        import_customer: 'Import Customer',
        export_customer: 'Export Customer',
        import_customers: 'Import Customers',
        import_supplier: 'Import Supplier',
        export_supplier: 'Export Supplier',
        import_suppliers: 'Import Suppliers',
        confirm_import: 'Confirm Import',
        download_sample: 'Download sample Excel',
        browse_import_file: 'Browse Excel file',
        load_import_file: 'Load file',
        import_notes_title: 'Import notes',
        select_all_eligible: 'Select all eligible',
        clear_selection: 'Clear selection',
        import_legend_ok: 'Eligible',
        import_legend_duplicate: 'Duplicate (red)',
        import_legend_disqualified: 'Disqualified (orange)',
        no_rows_loaded: 'Upload an Excel file to preview items here.',
        importing_items: 'Importing…',
        import_success: 'Import completed',
        revalidating: 'Checking against database…',
        item_code: 'Item code',
        item_name: 'Item name',
        sku: 'SKU',
        model_number: 'Model number',
        stock_quantity: 'Stock quantity',
        current_stock: 'Current Stock',
        reorder_level: 'Reorder level',
        manufacturing_date: 'Manufacturing date',
        expire_date: 'Expire date',
        item_serial_number: 'Item serial number',
        barcode_qr_code: 'Barcode',
        purchase_price: 'Purchase price',
        selling_price: 'Selling price',
        discount: 'Discount',
        vat_group: 'Vat group',
        vat_groups: 'Vat groups',
        create_item: 'Create item',
        select_manufacturing_date: 'Select manufacturing date',
        select_expire_date: 'Select expire date',
        new_item: "New item",
        back_to_item: "Back to items",
        general_information: "General information",
        item_details: "Item details",
        inventory_information: "Inventory information",
        item_information: "Item information",
        pricing_information: "Pricing information",
        add_new: "Add new",
        images: "Images",
        add_images: "Add images",
        edit_item: "Edit item",
        variant: "Variant",
        variant_details: "Variant details",
        variant_image: "Variant Image",
        variant_list: "Variant list",
        view_variants: "View variants",
        edit_variant: "Edit variant",
        life_cycle: "Life cycle",
        batch_details: "Batch details",
        batch_details_empty: "No batches found",
        batch_details_empty_hint: "Purchase and open-stock batches for this item will appear here.",
        batch_details_load_failed: "Could not load batch details.",
        current_quantity: "Current quantity",
        open_stock: "Open stock",
        purchase: "Purchase",
        sale: "Sale",
        sale_return: "Sale return",
        damage: "Damage",
        transfer_in: "Transfer in",
        transfer_out: "Transfer out",
        who: "Who",
        when: "When",
        how: "How",
        loading: "Loading",
        life_cycle_empty: "No stock movements yet",
        life_cycle_empty_hint: "Purchase, open stock, sales, returns and damage for this item will appear here.",
        life_cycle_load_failed: "Could not load item life cycle.",
        no_variants_found: "No variants found",
        no_variants_found_hint: "This item has no variants yet.",
        no_variants_found_list_hint: "Try adjusting filters or create variant items.",
        attributes: "Attributes",
        add_new_attribute: "Add new attribute",
        attribute_name: "Attribute name",
        image: "Image",
        no_image: "No image",
        income_head_name: "Income head name",
        income_head: "Income head",
        new_income_head: "New income head",
        create_income_head: "Create income head",
        add_new_income_head: "Add new income head",
        edit_income_head: "Edit income head",
        expense_head: "Expense head",
        expense_head_name: "Expense head name",
        add_new_expense_head: "Add new expense head",
        new_expense_head: "New expense head",
        create_expense_head: "Create expense head",
        back_to_list: "Back",
        edit_expense_head: "Edit expense head",
        customer_due: "Customer due",
        add_new_customer_due: "Add new customer due",
        customer_name: "Customer name",
        new_customer_due: "New customer due",
        create_customer_due: "Create customer due",
        edit_customer_due: "Edit customer due",
        supplier_due: "Supplier due",
        add_new_supplier_due: "Add new supplier due",
        new_supplier_due: "New supplier due",
        create_supplier_due: "Create supplier due",
        edit_supplier_due: "Edit supplier due",
        bank_account_list: "Bank account",
        add_new_bank_account: "Add new bank account",
        bank_account_number: "Bank account number",
        new_bank_account: "New bank account",
        create_bank_account: "Create bank account",
        edit_bank_account: "Edit bank account",
        inventory_batch_list:"Purchase",
        add_new_batch:"Add new purchase",
        new_batch:"New purchase",
        search_item_by_name_code:"Search item by name, code",
        add:"Add",
        customer_list:"Customer",
        add_new_customer:"Add new customer",
        edit_customer:"Edit customer",
        new_customer:"New customer",
        create_customer:"Create customer",
        enter_customer_name:"Enter customer name",
        enter_phone_number:"Enter phone number",
        enter_customer_code:"Enter customer code",
        enter_due_limit:"Enter due limit",
        enter_due_limit_days:"Enter due limit days",
        enter_customer_address:"Enter customer address",
        enter_customer_bank:"Enter customer bank",
        enter_contact_person:"Enter contact person",
        enter_email:"Enter email",
        setting_list:"Setting",
        edit_configuration:"Edit configuration",
        select_customer: 'Select customer',
        search_customer_by_name_phone:"Search customer by name, phone",
        select_supplier:"Select supplier",
        search_supplier_by_name_phone:"Search supplier by name, phone",
        item_return_entry:"Sales return",
        customer_due_receive_entry:"Customer due receive",
        supplier_due_entry:"Supplier due payment",
        damage_item_entry:"Damage item",
        store_transfer_entry:"Store transfer",
        store_transfer_list: 'Store transfer list',
        new_store_transfer: 'New transfer',
        discount_campaign_list: 'Discount',
        add_discount_campaign: 'Add Discount Campaign',
        edit_discount_campaign: 'Edit Discount Campaign',
        campaign_details: 'Campaign Details',
        campaign_name: 'Campaign Name',
        discount_type: 'Discount Type',
        discount_value: 'Discount Value',
        number_of_items: 'Number of Items',
        start_date_time: 'Start Date & Time',
        end_date_time: 'End Date & Time',
        created_by: 'Created By',
        basic_information: 'Basic Information',
        campaign_validity: 'Campaign Validity',
        discount_configuration: 'Discount Configuration',
        percentage_discount: 'Percentage Discount',
        fixed_amount_discount: 'Fixed Amount Discount',
        promotional_selling_price: 'Promotional Selling Price',
        max_discount_amount: 'Maximum Discount Amount per Unit',
        store_selection: 'Store Selection',
        all_authorized_stores: 'All authorized stores',
        item_selection: 'Item Selection',
        select_all_filtered: 'Select all filtered',
        deselect_all: 'Deselect all',
        selected_items: 'Selected items',
        no_items_selected: 'No items selected',
        search_item_sku_barcode: 'Search by name, code, SKU or barcode',
        all_categories: 'All categories',
        all_sub_categories: 'All sub categories',
        start_date: 'Start Date',
        start_time: 'Start Time',
        end_date: 'End Date',
        end_time: 'End Time',
        date_from: 'Date from',
        date_to: 'Date to',
        priority: 'Priority',
        description: 'Description',
        variant: 'Variant',
        promotional_price: 'Promotional Price',
        results: 'results',
        stores: 'Stores',
        status_draft: 'Draft',
        status_scheduled: 'Scheduled',
        status_active: 'Active',
        status_paused: 'Paused',
        status_expired: 'Expired',
        status_cancelled: 'Cancelled',
        activate: 'Activate',
        pause: 'Pause',
        confirm_activate_campaign: 'Activate this campaign?',
        confirm_pause_campaign: 'Pause this campaign?',
        confirm_cancel_campaign: 'Cancel this campaign? This cannot be undone.',
        campaign_created: 'Campaign created successfully',
        campaign_updated: 'Campaign updated successfully',
        start_must_be_before_end: 'Start date-time must be earlier than end date-time.',
        percentage_range_error: 'Percentage must be greater than 0 and at most 100.',
        fixed_discount_error: 'Fixed discount must be greater than 0.',
        promo_price_error: 'Promotional price cannot be negative.',
        campaign_discount: 'Campaign discount',
        something_went_wrong: 'Something went wrong',
        sl: 'SL',
        view: 'View',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        update: 'Update',
        sku: 'SKU',
        barcode: 'Barcode',
        selling_price: 'Selling Price',
        discount: 'Discount',
        action: 'Action',
        status: 'Status',
        no_data_found: 'No data found',

        store_transfer_coming_soon: 'Transfer form will be added in the next step.',
        transfer_voucher_no: 'Transfer voucher no',
        transfer_voucher_date: 'Transfer voucher date',
        from_store: 'From store',
        to_store: 'To store',
        transfer_qty: 'Transfer qty',
        total_transfer_amount: 'Total transfer amount',
        same_store_transfer_error: 'From store and To store must be different.',
        select_from_store_first: 'Please select From store first.',
        select_item_first: 'Please select an item first.',
        enter_valid_quantity: 'Please enter a valid quantity.',
        insufficient_stock: 'Insufficient stock.',
        insufficient_stock_detail: 'Insufficient stock. Available: {available}, required: {required}.',
        item_already_added: 'This item/variant has already been added.',
        add_at_least_one_item: 'Please add at least one item.',
        voucher_number_missing: 'Voucher number is missing. Please change date or refresh.',
        store_transfer_saved: 'Transfer sent — waiting for the destination store to accept.',
        store_transfer_save_failed: 'Failed to save store transfer.',
        transfer_tab_all: 'All',
        transfer_tab_pending_in: 'Pending inbound',
        transfer_tab_pending_out: 'Pending outbound',
        transfer_tab_completed: 'Completed',
        transfer_tab_rejected: 'Rejected',
        transfer_status_pending: 'Pending',
        transfer_status_accepted: 'Accepted',
        transfer_status_rejected: 'Rejected',
        transfer_status_cancelled: 'Cancelled',
        pending_inbound_transfers: '{count} pending transfer(s) to accept',
        accept_transfer: 'Accept',
        reject_transfer: 'Reject',
        cancel_transfer: 'Cancel',
        transfer_pdf: 'PDF',
        transfer_document_failed: 'Could not open the transfer document.',
        reject_note: 'Reject note',
        view_reject_note: 'Note',
        reject_note_from_receiver: 'From {store}',
        reject_note_placeholder: 'Why are you rejecting this item?',
        reject_note_required: 'Please enter a reject note.',
        confirm_accept_transfer: 'Accept this transfer and add stock to this store?',
        confirm_accept_transfer_item: 'Accept this item and add stock to this store?',
        confirm_reject_transfer: 'Reject this transfer? Stock will return to the sender.',
        confirm_reject_transfer_item: 'Reject this item? Stock will return to the sender.',
        confirm_cancel_transfer: 'Cancel this transfer? Stock will be restored to this store.',
        confirm_cancel_transfer_item: 'Cancel this item? Stock will be restored to this store.',
        transfer_updated: 'Transfer updated.',
        transfer_action_failed: 'Could not update the transfer.',
        try_adjusting_filters: 'Try another tab or create a new transfer.',
        from_store_header_mismatch: 'Header active store differs from From store. Switch header store to From store so stock quantity matches.',
        saving: 'Saving...',
        select_voucher:'Select voucher',
        search_voucher: 'Search Voucher',
        search_item: 'Search Item',
        search_item_by_name_barcode: 'Search item by name, barcode',
        search_item_by_name_barcode_serial: 'Search by name, barcode or serial',
        total_discount:'Total discount',
        total_vat:'Total vat',
        total_price:'Total price',
        return_qty:'Return Qty',
        return_total_price:'Return total price',
        no_data_found:'No Data Found',
        search: "Search",
        clear: "Clear",
        reference_no:"Reference No",
        total:'Total',
        paid:'Paid',
        due:'Due',
        enter_reference_no:"Enter reference no",
        search_voucher_by:"Search invoice by 4",
        search_voucher_by_id:"Search invoice by 7",
        purchase_return:"Purchase return",
        sales_return_list:"Sales return list",
        new_sales_return:"New sales return",
        return_voucher_no:"Return voucher no",
        return_voucher_date:"Return voucher date",
        sales_voucher_no:"Sales voucher no",
        sales_voucher_date:"Sales voucher date",
        total_return_price:"Total return price",
        user_name:"Username",
        user_email:"User email",
        user_group:"User group",
        user_list:"User list",
        user_role: "User role",
        add_new_user: "Add new user",
        edit_user: "Edit user",
        new_user: "New user",
        role_name: "Role name",
        edit_role: "Edit role",
        description: "Description",
        enter_description: "Enter description",
        enter_role_name: "Enter role name",
        email: "Email",
        password: "Password",
        confirm_password: "Confirm password",
        enter_user_name: "Enter username",
        enter_password: "Enter password",
        enter_confirm_password: "Re-enter password",
        password_not_match: "Passwords do not match",
        role_list: "Role list",
        add_new_role: "Add new role",
        new_role: "New role",
        user_type: "User type",
        item_with_stock: "Add Stock ?",
        warranty_period_days: "Warranty Days",
        warranty_period_days_hint: "Default days; can override at purchase",
        warranty_period_required: "Warranty days are required",
        warranty_variant_optional_hint: "Variant selection is optional for products with a warranty.",
        optional: "Optional",
        reset: "Reset",
        add_variant: "Add Variant ?",
        add_variant_optional_hint_before: "You can skip this step and add variants later from",
        add_variant_optional_hint_path: "Purchase → Purchase Entry",
        add_variant_optional_hint_after: ".",
        add_warranty_variant_optional_hint_before: "Select ",
        add_warranty_variant_optional_hint_middle: " to add multiple variants. Add stock later via ",
        add_warranty_variant_optional_hint_path: "Purchase → Purchase Entry",
        add_warranty_variant_optional_hint_after: ".",
        add_stock_optional_hint_before: "You can skip this step and add stock later from",
        add_stock_optional_hint_path: "Purchase → Purchase Entry",
        add_stock_optional_hint_after: ".",
        serial_numbers: "Serial numbers",
        serial_number: "Serial number",
        serial_numbers_hint: "One serial per line (or comma-separated)",
        no_sold_serials_for_return: "No sold serial numbers left to return for this item on the selected invoice.",
        serial_scan_enter_hint: "Type or scan serial, then press Enter",
        serial_count_mismatch: "Serial count must match quantity",
        serial_pick_or_scan: "Scan or type exact serials (one per unit)",
        available_serials: "Available serials",
        scan_warranty_serial: "Scan the product serial number to sell",
        serial_already_in_cart: "This serial is already in the cart",
        serial_already_added: "This serial is already added",
        serial_already_added_in_grid: "Duplicate serial number: {serial}. This serial is already added in the grid.",
        serial_number_already_exist: "Serial Number already exist",
        no_unsold_serials: "No in-stock serial numbers left to return for this product on the selected purchase voucher.",
        warranty_separate_purchase_entry:
          "Warranty products must be received in a separate purchase entry. They cannot be mixed with other item types.",
        warranty_cannot_mix_with_other_types:
          "Warranty type product cannot be mixed with other type products.",
        non_warranty_cannot_add_to_warranty_grid:
          "No-variant and multi-variant products cannot be added to a warranty product grid.",
        current_invoice_quantity: "Current invoice quantity",
        days: "Days",
        months: "Months",
        customer_due_receive_list: "Customer due receive list",
        total_paid_amount: "Total paid amount",
        new_due_receive: "New due receive",
        purchase_return_list: "Purchase return list",
        new_purchase_return: "New purchase return",
        purchase_voucher_no: "Purchase voucher no",
        purchase_voucher_date: "Purchase voucher date",
        supplier_due_payable_list: "Supplier due payable list",
        new_due_pay: "New due pay",
        start_date: "Start date",
        end_date: "End date",
        configuration: "Configuration",
        vat_group_name: "Vat group name",
        vat_value: "Vat value",
        vat_groups_managed_by_platform: "VAT groups are shared by all shops and managed by the platform. Contact support to request a new rate.",
        barcode_print: "Barcode print",
        total_quantity: "Total quantity",
        print_qty: "Print quantity",
        print_preview: "Print preview",
        invoice_style: "Invoice style",
        invoice_setting: "Business Info",
        add_new_setting: "Add new setting",
        business_name: "Business name",
        business_phone: "Business phone",
        business_address: "Business address",
        show_tin: "Show tin",
        show_bin: "Show bin",
        show_barcode: "Show barcode",
        show_logo: "Show logo",
        powered_by: "Powered by",
        edit_setting: "Edit setting",
        create_invoice_setting: "Create invoice setting",
        header_message: "Header message",
        footer_message: "Footer message",
        select_store: "Select store",
        item_type: "Item Type",
        Yes: "Yes",
        No: "No",
        enter_chalan_no: "Enter chalan no",
        enter_batch_no: "Optional — auto if empty",
        enter_lot_no: "Optional — auto if empty",
        add_new_variant: "Add new variant",
        variants_added_to_item_alert:
          'Variants <span style="color:#198754;font-weight:700;">SUCCESSFULLY</span> added to the item. You can search them later using the search option in Purchase Entry.',
        success: "Success",
        batch_selling_price: 'Batch Sale Price',
        damages_item_list: 'Damage item list',
        new_damage: 'New damage',
        damage_voucher_no: 'Damage voucher no',
        damage_voucher_date: 'Damage voucher date',
        damage_qty: 'Damage qty',
        total_damage_amount: 'Total damage amount',
        sales_item_list: 'Sales item list',
        sale_voucher_no: 'Sale voucher no',
        sale_voucher_date: 'Sale voucher date',
        total_sale_amount: 'Total sale amount',
        sale_qty: 'Sale qty',
        vat: 'Vat',
        batch: 'Batch',


        // db table fields
        node: "Category",
        status: "status",
        head_status: "head_status",
        account_id: "Account ID",
        action: "Action",
        created_at: "Created At",
        created_by: "Created By",
        updated_at: "Updated At",
        updated_by: "Updated By",
        size: "Size",
        color: "Color",
        name: "Name",
        address: "Address",
        phone_number: "Phone number",
        unit: "Unit",
        chalan_no:"Chalan no",
        chalan_date:"Chalan date",
        batch_no:" Batch no",
        lot_no:"Lot no",
        costing_unit_price:"Costing unit price",
        quantity:"Quantity",
        total_amount:"Total amount",
        in_house_date:"In house date",
        expiry_date:"Expiry date",
        unit_price:"Unit price",
        amount:"Amount",
        receiving_no:"Voucher no",
        receiving_date:"Voucher date",
        payment_type:"Payment type",
        bank_account: "Bank account",
        customer_code:"Customer code",
        due_limit:"Due limit",
        due_limit_days:"Due limit days",
        customer_address:"Customer address",
        customer_bank:"Customer bank",
        customer_contact_person:"Customer contact person",
        customer_email:"Customer email",
        customer_phone:"Customer phone",
        supplier_phone:"Supplier phone",
        batch_policy:"Batch policy",
        discount_policy:"Discount Record Policy",
        global_discount_percentage: "Global Discount Percentage (%)",
        discount_source_policy: "Discount Source Policy",
        global_vat_percentage:"Global VAT Percentage (%)",
        vat_policy:"Vat Source Policy",
        selling_price_policy: "Selling Price Policy",
        invoice_rounding_policy: "Invoice Rounding Policy",
        voucher_no:"Voucher no",
        voucher_date:"Voucher date",
        narration:"Narration",
        head:"Head",

        error: {
          required: 'This field is required.',
          field_required: '{field} is required.',
          field_gt_zero: '{field} must be greater than zero.',
          generate_variants_first: 'Variants are required. Generate variants first.',
          duplicate_variant_barcodes: 'Duplicate variant barcodes in this form.',
          variant_barcode_matches_item: 'Variant barcode cannot match the item barcode.',
          invalid_phone: 'Enter a valid phone number (11-15 digits).',
          generic_error: 'Something went wrong, please try again.',
          max_images: "You can only upload a maximum of 2 images.",
        },

        // debit voucher
        debit_voucher:"Debit Voucher",
        add_debit_voucher:"Add Debit Voucher",
        credit_voucher:"Credit Voucher",
        add_credit_voucher:"Add Credit Voucher",
        journal_voucher:"Journal Voucher",
        add_journal_voucher:"Add Journal Voucher",
        debit_item:"Debit Item",
        credit_item:"Credit Item",
        debit_amount:"Debit Amount",
        credit_amount:"Credit Amount",
        total_debit:"Total Debit",
        total_credit: "Total Credit",

        contra_voucher:"Contra Voucher",
        add_contra_voucher:"Add Contra Voucher",
        chart_of_accounts:"Chart Of Accounts",
        add_new_accounts: "Add New Accounts",
        account_name:"Account Name",
        account_no:"Account No.",
        parent_account:"Parent Account",
        child_account_name:"Child Account Name",
        update_accounts: "Update Accounts",
        accounts:"Accounts",

        bill_receivable:"Bill Receivable",
        bill_payable:"Bill Payable",
        income:"Income",
        expense:"Expense",
        transaction_category:"Transaction",
        expense_voucher:'Expense Voucher',
        add_expense_voucher:'Add Expense Voucher',
        income_voucher:'Income Voucher',
        add_income_voucher:'Add Income Voucher',
        type:"Type",
        credit:'Credit',
        debit:"Debit",
        balance:"Balance",
        liabilities:"Liabilities",

        requisition:'Requisition',
        add_requisition:'Add Requisition',
        purchase_order:'Purchase Order',
        add_purchase_order:'Create Purchase Order',
        requisition_no:'Requisition No.',
        requisition_by:'Requisition By',
        requisition_date:'Requisition Date',
        priority:'Priority',
        number_of_items:'Number Of Items',
        order_date:'Order Date',

    },
    bn: {
        // ui static words
        submit: "সংরক্ষণ করুন",
        cancel: "বাতিল করুন",
        close: "বন্ধ",
        create: "তৈরি করুন",
        languageSwitched: "ভাষা সফলভাবে পরিবর্তিত হয়েছে!",
        add_new_category: "নতুন বিভাগ যোগ করুন",
        category: "বিভাগ",
        create_category: "বিভাগ তৈরি করুন",
        edit_category: "বিভাগ সম্পাদনা করুন",
        category_name: "বিভাগের নাম",
        sub_category: "উপ-বিভাগ",
        create_sub_category: "উপ-বিভাগ তৈরি করুন",
        add_new_sub_category: "নতুন উপ-বিভাগ যোগ করুন",
        select_category: "বিভাগ নির্বাচন করুন",
        select_an_option: "একটি অপশন নির্বাচন করুন",
        sub_category_name: "উপ-বিভাগের নাম",
        enter_sub_category_name: "উপ-বিভাগের নাম লিখুন",
        enter_category_name: "বিভাগের নাম লিখুন",
        edit_sub_category: "উপ-বিভাগ সম্পাদনা করুন",
        select_a_category: "একটি বিভাগ নির্বাচন করুন",
        item_size: "আইটেম সাইজ",
        add_new_item_size: "নতুন আইটেম সাইজ যোগ করুন",
        create_item_size: "আইটেম সাইজ তৈরি করুন",
        item_size_name: "আইটেম সাইজের নাম",
        edit_item_size: "আইটেম সাইজ সম্পাদনা করুন",
        item_color: "আইটেম রং",
        add_new_item_color: "নতুন আইটেম রং যোগ করুন",
        create_item_color: "আইটেম রং তৈরি করুন",
        item_color_name: "আইটেম রঙের নাম",
        edit_item_color: "আইটেম রং সম্পাদনা করুন",
        store: "স্টোর",
        add_new_store: "নতুন স্টোর যোগ করুন",
        store_name: "স্টোরের নাম",
        store_address: "স্টোরের ঠিকানা",
        store_phone_number: "স্টোরের ফোন নম্বর",
        create_store: "স্টোর তৈরি করুন",
        edit_store: "স্টোর সম্পাদনা করুন",
        warehouse: "গুদাম",
        add_new_warehouse: "নতুন গুদাম যোগ করুন",
        warehouse_name: "গুদামের নাম",
        warehouse_address: "গুদামের ঠিকানা",
        warehouse_phone_number: "গুদামের ফোন নম্বর",
        create_warehouse: "গুদাম তৈরি করুন",
        edit_warehouse: "গুদাম সম্পাদনা করুন",
        supplier: "সরবরাহকারী",
        customer: "গ্রাহক",
        party_type: "পার্টির ধরন",
        party_type_optional: "পার্টির ধরন (ঐচ্ছিক)",
        party: "পার্টি",
        add_new_supplier: "নতুন সরবরাহকারী যোগ করুন",
        supplier_name: "সরবরাহকারীর নাম",
        supplier_address: "সরবরাহকারীর ঠিকানা",
        supplier_phone_number: "সরবরাহকারীর ফোন নম্বর",
        create_supplier: "সরবরাহকারী তৈরি করুন",
        edit_supplier: "সরবরাহকারী সম্পাদনা করুন",
        measurement_unit: "ইউনিট",
        add_new_measurement_unit: "নতুন ইউনিট যোগ করুন",
        create_measurement_unit: "ইউনিট তৈরি করুন",
        edit_measurement_unit: "ইউনিট সম্পাদনা করুন",
        item: 'আইটেম',
        add_new_item: 'নতুন আইটেম যোগ করুন',
        import_item: 'আইটেম ইমপোর্ট',
        export_item: 'আইটেম এক্সপোর্ট',
        import_items: 'আইটেম ইমপোর্ট',
        import_customer: 'কাস্টমার ইমপোর্ট',
        export_customer: 'কাস্টমার এক্সপোর্ট',
        import_customers: 'কাস্টমার ইমপোর্ট',
        import_supplier: 'সাপ্লায়ার ইমপোর্ট',
        export_supplier: 'সাপ্লায়ার এক্সপোর্ট',
        import_suppliers: 'সাপ্লায়ার ইমপোর্ট',
        confirm_import: 'ইমপোর্ট নিশ্চিত করুন',
        download_sample: 'স্যাম্পল এক্সেল ডাউনলোড',
        browse_import_file: 'এক্সেল ফাইল বেছে নিন',
        load_import_file: 'ফাইল লোড করুন',
        import_notes_title: 'ইমপোর্ট নির্দেশনা',
        select_all_eligible: 'সব যোগ্য নির্বাচন',
        clear_selection: 'নির্বাচন মুছুন',
        import_legend_ok: 'যোগ্য',
        import_legend_duplicate: 'ডুপ্লিকেট (লাল)',
        import_legend_disqualified: 'অযোগ্য (কমলা)',
        no_rows_loaded: 'প্রিভিউ দেখতে একটি এক্সেল ফাইল আপলোড করুন।',
        importing_items: 'ইমপোর্ট হচ্ছে…',
        import_success: 'ইমপোর্ট সম্পন্ন',
        revalidating: 'ডাটাবেসের সাথে যাচাই হচ্ছে…',
        item_code: 'আইটেম কোড',
        item_name: 'আইটেমের নাম',
        sku: 'এসকেইউ',
        model_number: 'মডেল নম্বর',
        stock_quantity: 'স্টক পরিমাণ',
        current_stock: 'বর্তমান স্টক',
        reorder_level: 'পুনর্বিন্যাস স্তর',
        manufacturing_date: 'উৎপাদনের তারিখ',
        expire_date: 'মেয়াদ উত্তীর্ণের তারিখ',
        item_serial_number: 'আইটেম সিরিয়াল নম্বর',
        barcode_qr_code: 'বারকোড',
        purchase_price: 'ক্রয় মূল্য',
        selling_price: 'বিক্রয় মূল্য',
        discount: 'ডিসকাউন্ট',
        tax_group: 'ট্যাক্স গ্রুপ',
        create_item: 'আইটেম তৈরি করুন',
        select_manufacturing_date: 'উৎপাদনের তারিখ নির্বাচন করুন',
        select_expire_date: 'মেয়াদ উত্তীর্ণের তারিখ নির্বাচন করুন',
        new_item: "নতুন আইটেম",
        back_to_item: "আইটেমগুলিতে ফিরে যান",
        general_information: "সাধারণ তথ্য",
        item_details: "আইটেম বিবরণ",
        inventory_information: "ইনভেন্টরি তথ্য",
        pricing_information: "মূল্য তথ্য",
        add_new: "নতুন যোগ করুন",
        images: "ছবি",
        add_images: "ছবি যোগ করুন",
        edit_item: "আইটেম সম্পাদনা করুন",
        variant: "ভ্যারিয়েন্ট",
        variant_details: "ভ্যারিয়েন্ট বিবরণ",
        variant_image: "ভ্যারিয়েন্ট ছবি",
        variant_list: "ভ্যারিয়েন্ট তালিকা",
        view_variants: "ভ্যারিয়েন্ট দেখুন",
        edit_variant: "ভ্যারিয়েন্ট সম্পাদনা করুন",
        life_cycle: "লাইফ সাইকেল",
        batch_details: "ব্যাচ বিবরণ",
        batch_details_empty: "কোনো ব্যাচ পাওয়া যায়নি",
        batch_details_empty_hint: "এই আইটেমের ক্রয় ও ওপেন-স্টক ব্যাচ এখানে দেখা যাবে।",
        batch_details_load_failed: "ব্যাচ বিবরণ লোড করা যায়নি।",
        current_quantity: "বর্তমান পরিমাণ",
        open_stock: "ওপেন স্টক",
        purchase: "ক্রয়",
        sale: "বিক্রয়",
        sale_return: "বিক্রয় ফেরত",
        damage: "ক্ষতি",
        transfer_in: "ট্রান্সফার ইন",
        transfer_out: "ট্রান্সফার আউট",
        who: "কে",
        when: "কখন",
        how: "কীভাবে",
        loading: "লোড হচ্ছে",
        life_cycle_empty: "এখনও কোনো স্টক চলাচল নেই",
        life_cycle_empty_hint: "এই আইটেমের ক্রয়, ওপেন স্টক, বিক্রয়, ফেরত ও ক্ষতি এখানে দেখা যাবে।",
        life_cycle_load_failed: "আইটেম লাইফ সাইকেল লোড করা যায়নি।",
        balance: "ব্যালেন্স",
        no_variants_found: "কোনো ভ্যারিয়েন্ট পাওয়া যায়নি",
        no_variants_found_hint: "এই আইটেমে এখনও কোনো ভ্যারিয়েন্ট নেই।",
        no_variants_found_list_hint: "ফিল্টার সামঞ্জস্য করুন অথবা ভ্যারিয়েন্ট আইটেম তৈরি করুন।",
        attributes: "অ্যাট্রিবিউটস",
        add_new_attribute: "নতুন অ্যাট্রিবিউট যোগ করুন",
        attribute_name: "অ্যাট্রিবিউটের নাম",
        image: "ছবি",
        no_image: "ছবি নেই",
        income_head_name: "আয়ের খাতের নাম",
        income_head: "আয়ের খাত",
        new_income_head: "নতুন আয়ের খাত",
        create_income_head: "আয়ের খাত তৈরি করুন",
        add_new_income_head: "নতুন আয়ের খাত যোগ করুন",
        edit_income_head: "আয়ের খাত সম্পাদনা করুন",
        expense_head: "খরচের খাত",
        expense_head_name: "খরচের খাতের নাম",
        add_new_expense_head: "নতুন খরচের খাত যোগ করুন",
        new_expense_head: "নতুন খরচের খাত",
        create_expense_head: "খরচের খাত তৈরি করুন",
        back_to_list: "তালিকায় ফিরে যান",
        edit_expense_head: "খরচের খাত সম্পাদনা করুন",
        customer_due: "গ্রাহক বকেয়া",
        add_new_customer_due: "নতুন গ্রাহক বকেয়া যোগ করুন",
        customer_name: "গ্রাহকের নাম",
        new_customer_due: "নতুন গ্রাহক বকেয়া",
        create_customer_due: "গ্রাহক বকেয়া তৈরি করুন",
        edit_customer_due: "গ্রাহক বকেয়া সম্পাদনা করুন",
        supplier_due: "সরবরাহকারীর বকেয়া",
        add_new_supplier_due: "নতুন সরবরাহকারীর বকেয়া যোগ করুন",
        new_supplier_due: "নতুন সরবরাহকারীর বকেয়া",
        create_supplier_due: "সরবরাহকারীর বকেয়া তৈরি করুন",
        edit_supplier_due: "সরবরাহকারীর বকেয়া সম্পাদনা করুন",
        bank_account_list: "ব্যাংক অ্যাকাউন্ট",
        add_new_bank_account: "নতুন ব্যাংক অ্যাকাউন্ট যোগ করুন",
        bank_account_number: "ব্যাংক অ্যাকাউন্ট নাম্বার",
        new_bank_account: "নতুন ব্যাংক অ্যাকাউন্ট",
        create_bank_account: "ব্যাংক অ্যাকাউন্ট তৈরি করুন",
        edit_bank_account: "ব্যাংক অ্যাকাউন্ট সম্পাদনা করুন",
        inventory_batch_list:"ইনভেন্টরি ক্রয়",
        search_item_by_name_code:"নাম, কোড অনুসারে আইটেম অনুসন্ধান করুন",
        add:"যোগ করুন",
        warranty_period_days: "ওয়ারেন্টি দিন",
        warranty_period_days_hint: "ডিফল্ট দিন; ক্রয়ে পরিবর্তনযোগ্য",
        warranty_period_required: "ওয়ারেন্টি দিন প্রয়োজন",
        warranty_variant_optional_hint: "ওয়ারেন্টি পণ্যের জন্য ভ্যারিয়েন্ট নির্বাচন ঐচ্ছিক।",
        optional: "ঐচ্ছিক",
        reset: "রিসেট",
        add_variant: "ভ্যারিয়েন্ট যোগ করবেন ?",
        add_variant_optional_hint_before: "এই ধাপটি এড়িয়ে যেতে পারেন এবং পরে ভ্যারিয়েন্ট যোগ করতে পারেন",
        add_variant_optional_hint_path: "ক্রয় → ক্রয় এন্ট্রি",
        add_variant_optional_hint_after: " থেকে।",
        add_warranty_variant_optional_hint_before: "একাধিক ভ্যারিয়েন্ট যোগ করতে ",
        add_warranty_variant_optional_hint_middle: " নির্বাচন করুন। পরে স্টক যোগ করুন ",
        add_warranty_variant_optional_hint_path: "ক্রয় → ক্রয় এন্ট্রি",
        add_warranty_variant_optional_hint_after: " থেকে।",
        add_stock_optional_hint_before: "এই ধাপটি এড়িয়ে যেতে পারেন এবং পরে স্টক যোগ করতে পারেন",
        add_stock_optional_hint_path: "ক্রয় → ক্রয় এন্ট্রি",
        add_stock_optional_hint_after: " থেকে।",
        serial_number: "সিরিয়াল নম্বর",
        serial_scan_enter_hint: "সিরিয়াল টাইপ বা স্ক্যান করে Enter চাপুন",
        serial_already_added: "এই সিরিয়াল ইতিমধ্যে যোগ করা হয়েছে",
        serial_already_added_in_grid: "ডুপ্লিকেট সিরিয়াল নম্বর: {serial}। এই সিরিয়াল ইতিমধ্যে গ্রিডে যোগ করা হয়েছে।",
        serial_number_already_exist: "সিরিয়াল নম্বর ইতিমধ্যে আছে",
        no_unsold_serials: "নির্বাচিত ক্রয় ভাউচারে এই পণ্যের ফেরত দেওয়ার মতো কোনো স্টকে থাকা সিরিয়াল নম্বর নেই।",
        warranty_separate_purchase_entry:
          "ওয়ারেন্টি পণ্য আলাদা ক্রয় এন্ট্রিতে নিতে হবে। অন্য আইটেম টাইপের সাথে একসাথে মেশানো যাবে না।",
        warranty_cannot_mix_with_other_types:
          "ওয়ারেন্টি টাইপ পণ্য অন্য টাইপ পণ্যের সাথে মেশানো যাবে না।",
        non_warranty_cannot_add_to_warranty_grid:
          "নো-ভ্যারিয়েন্ট ও মাল্টি-ভ্যারিয়েন্ট পণ্য ওয়ারেন্টি পণ্যের গ্রিডে যোগ করা যাবে না।",
        current_invoice_quantity: "বর্তমান ইনভয়েস পরিমাণ",
        days: "দিন",
        customer_list:"গ্রাহক",
        add_new_customer:"নতুন গ্রাহক যোগ করুন",
        edit_customer:"গ্রাহক সম্পাদনা করুন",
        new_customer:"নতুন গ্রাহক",
        create_customer:"নতুন গ্রাহক তৈরি করুন",
        enter_customer_name:"গ্রাহকের নাম লিখুন",
        enter_phone_number:"ফোন নম্বর লিখুন",
        enter_customer_code:"গ্রাহক কোড লিখুন",
        enter_due_limit:"বকেয়া সীমা লিখুন",
        enter_due_limit_days:"নির্ধারিত সীমা দিন লিখুন",
        enter_customer_address:"গ্রাহকের ঠিকানা লিখুন",
        enter_customer_bank:"গ্রাহকের ব্যাংক অ্যাকাউন্ট লিখুন",
        enter_contact_person:"গ্রাহক যোগাযোগ ব্যক্তি লিখুন",
        enter_email:"ইমেইল লিখুন",
        password: "পাসওয়ার্ড",
        confirm_password: "পাসওয়ার্ড নিশ্চিত করুন",
        enter_user_name: "ইউজারনেম লিখুন",
        enter_password: "পাসওয়ার্ড লিখুন",
        enter_confirm_password: "পুনরায় পাসওয়ার্ড লিখুন",
        password_not_match: "পাসওয়ার্ড মিলছে না",
        setting_list:"সেটিং",
        edit_setting:"সেটিং সম্পাদনা করুন",
        select_customer: 'গ্রাহকের নির্বাচন করুন',
        no_data_found: 'কোনো তথ্য পাওয়া যায়নি',
        search: "অনুসন্ধান",
        clear: "মুছুন",
        search_customer_by_name_phone:"নাম, ফোন অনুসারে গ্রাহক অনুসন্ধান করুন",
        select_supplier:"সরবরাহকারী নির্বাচন করুন",
        search_supplier_by_name_phone:"নাম, ফোন অনুসারে সরবরাহকারী খুঁজুন",
        item_return_entry:"আইটেম ",
        customers_due_receive_entry:"আইটেম ",
        reference_no:"রেফারেন্স নং",
        total:'মোট টাকা',
        paid:'পরিশোধ',
        due:'বকেয়া',
        enter_reference_no:"রেফারেন্স নম্বর লিখুন",

        // db table fields
        node: "বিভাগ",
        status: "স্ট্যাটাস",
        head_status: "হেড-স্ট্যাটাস",
        account_id: "অ্যাকাউন্ট আইডি",
        action: "কার্যক্রম",
        created_at: "তৈরি হয়েছে",
        created_by: "তৈরি করেছেন",
        updated_at: "আপডেটের তারিখ",
        updated_by: "আপডেট করেছেন",
        size: "সাইজ",
        color: "রং",
        name: "নাম",
        address: "ঠিকানা",
        phone_number: "ফোন নম্বর",
        unit: "ইউনিট",
        chalan_no:"চালান নং",
        chalan_date:"চালান তারিখ",
        batch_no:" ব্যাচ নং",
        lot_no:"লট নং",
        costing_unit_price:"ইউনিট খরচ মূল্য",
        quantity:"পরিমাণ",
        total_amount:"মোট পরিমাণ",
        in_house_date:"ইন-হাউস তারিখ",
        expiry_date:"মেয়াদ শেষ হওয়ার তারিখ",
        unit_price:"ইউনিট মূল্য",
        amount:"টাকা",
        receiving_no:"প্রাপ্তি নম্বর",
        receiving_date:"প্রাপ্তির তারিখ",
        payment_type:"পেমেন্টের ধরন",
        bank_account:"ব্যাংক অ্যাকাউন্ট",
        customer_code:"গ্রাহক কোড",
        due_limit:"বকেয়া সীমা",
        due_limit_days:"নির্ধারিত সীমা দিন",
        customer_address:"গ্রাহকের ঠিকানা",
        customer_bank:"গ্রাহক ব্যাংক",
        customer_contact_person:"গ্রাহক যোগাযোগ ব্যক্তি",
        customer_email:"গ্রাহক ইমেল",
        customer_phone:"গ্রাহকের ফোন",
        supplier_phone:"সরবরাহকারীর ফোন",
        batch_policy:"ব্যাচ নীতি",
        discount_policy:"ডিসকাউন্ট নীতি",
        vat_percentage:"ভ্যাট শতাংশ",
        vat_policy:"ভ্যাট নীতি",
        selling_price_policy: "বিক্রয় মূল্য নীতি",
        invoice_rounding_policy: "ইনভয়েস রাউন্ডিং নীতি",
        voucher_no:"ভাউচার নং",
        voucher_date:"ভাউচার তারিখ",
        narration:"বর্ণনা",


        error: {
          required: 'এই ক্ষেত্রটি প্রয়োজন।',
          field_required: '{field} প্রয়োজন।',
          field_gt_zero: '{field} শূন্যের বেশি হতে হবে।',
          generate_variants_first: 'ভ্যারিয়েন্ট প্রয়োজন। আগে ভ্যারিয়েন্ট তৈরি করুন।',
          duplicate_variant_barcodes: 'এই ফর্মে ডুপ্লিকেট ভ্যারিয়েন্ট বারকোড আছে।',
          variant_barcode_matches_item: 'ভ্যারিয়েন্ট বারকোড আইটেম বারকোডের সাথে মিলতে পারে না।',
          invalid_phone: 'একটি সঠিক ফোন নম্বর (১১-১৫ ডিজিট) দিন।',
          generic_error: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন।',
          max_images: 'আপনি সর্বোচ্চ ২টি ছবি আপলোড করতে পারবেন।',
        },
        discount_campaign_list: 'ডিসকাউন্ট',
        add_discount_campaign: 'ডিসকাউন্ট ক্যাম্পেইন যোগ করুন',
        edit_discount_campaign: 'ডিসকাউন্ট ক্যাম্পেইন সম্পাদনা',
        campaign_details: 'ক্যাম্পেইন বিবরণ',
        campaign_name: 'ক্যাম্পেইনের নাম',
        discount_type: 'ডিসকাউন্টের ধরন',
        discount_value: 'ডিসকাউন্ট মূল্য',
        number_of_items: 'আইটেম সংখ্যা',
        start_date_time: 'শুরুর তারিখ ও সময়',
        end_date_time: 'শেষ তারিখ ও সময়',
        created_by: 'তৈরি করেছেন',
        status_draft: 'খসড়া',
        status_scheduled: 'নির্ধারিত',
        status_active: 'সক্রিয়',
        status_paused: 'বিরতি',
        status_expired: 'মেয়াদোত্তীর্ণ',
        status_cancelled: 'বাতিল',
        activate: 'সক্রিয় করুন',
        pause: 'বিরতি দিন',
        campaign_discount: 'ক্যাম্পেইন ডিসকাউন্ট',
        something_went_wrong: 'কিছু সমস্যা হয়েছে',
    },
};

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: localStorage.getItem('lang') || 'en',
    messages,
});

export default i18n;
